module.exports = __webpack_public_path__ + "static/media/Le Phu Quoc‎ 01.ffa6780f.jpg";